import { Link } from 'react-router-dom';
import type { Playlist } from '../types';

export function PlaylistCard({
  playlist,
  trackCount,
  onRename,
  onDelete
}: {
  playlist: Playlist;
  trackCount: number;
  onRename: () => void;
  onDelete: () => void;
}) {
  return (
    <article className="panel rounded-[2rem] p-5">
      <p className="text-xs uppercase tracking-[0.3em] text-accent">Playlist</p>
      <h3 className="mt-3 font-display text-2xl font-semibold">{playlist.name}</h3>
      <p className="mt-2 text-sm text-foreground/65">{trackCount} saved tracks</p>
      <div className="mt-6 flex gap-3">
        <Link to={`/playlists/${playlist.id}`} className="rounded-full bg-accent px-4 py-2 text-sm font-semibold text-black">
          Open
        </Link>
        <button type="button" onClick={onRename} className="pill">
          Rename
        </button>
        <button type="button" onClick={onDelete} className="pill text-danger">
          Delete
        </button>
      </div>
    </article>
  );
}
